<div class="row">
  @for (dataPoint of postHarvestDataPoints; track dataPoint) {
    <div class="col-sm-3">
      <mat-form-field>
        <mat-label>{{dataPoint.name}}</mat-label>
        <input matInput [disabled]="!canEditHarvest" [(ngModel)]="postHarvestData[dataPoint.systemValue]">
      </mat-form-field>
    </div>
  }
</div>